import { styled } from "baseui";

export const CodeNavTitle = styled("span", ({ $theme }) => ({
  fontFamily: $theme.typography.MonoHeadingMedium.fontFamily,
  fontSize: "15px",
}));
